import React, { useEffect, useState } from 'react';

// Material UI
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

// Components
import PurchaseItem from './PurchaseItem';

import useStyles from './styles';
import { Collapse, IconButton, useMediaQuery, useTheme } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';

const ItemsList = ({ title, items, warehouses, currency, onDelete, onRemove, onAdd, onEditPrice, disabled }) => {
    const { classes } = useStyles();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('xl'));
    const [expanded, setExpanded] = useState(matches);

    useEffect(() => {
        setExpanded(matches)
    }, [matches])

    const GetWarehouseName = ( warehouseId ) =>
        warehouses?.find(w => w.id === warehouseId)?.name || '';

    return (
        <>
            {
                items && !!items.length &&
                <Grid container direction='column' className={classes.products} spacing={1}>
                    <Grid container justifyContent='space-between' alignItems='center'>
                        <Typography variant='h5' component='span'>
                            {title}
                            <Typography variant='h5' component='span' color='primary'>
                                {items && ` (${items?.map(e => e.quantity)?.reduce((a, b) => a + b)})`}
                            </Typography>
                        </Typography>
                        <IconButton onClick={() => setExpanded(!expanded)} size="large">
                            {expanded ? <ExpandLess /> : <ExpandMore />}
                        </IconButton>
                    </Grid>
                    <Grid size={12}>
                        <Collapse in={expanded}>
                            <Grid container spacing={1}>
                            {
                                items.map((item, index) =>
                                    <div key={`${item.refId}-${item.warehouseId}`}>
                                        <Grid>
                                            <PurchaseItem
                                                item={item}
                                                currency={currency}
                                                promotions={item.promotions}
                                                onAdd={onAdd}
                                                onRemove={onRemove}
                                                onDelete={onDelete}
                                                onEditPrice={onEditPrice}
                                                warehouseName={GetWarehouseName(item.warehouseId)}
                                                disabled={disabled}
                                            />
                                        </Grid>
                                        {
                                            index < items.length - 1 &&
                                            <Grid size={12}>
                                                <Divider />
                                            </Grid>
                                        }
                                    </div>
                                )
                            }
                            </Grid>
                        </Collapse>
                    </Grid>
                </Grid>
            }
        </>
    );
}

export default ItemsList;